<template>
    <q-dialog
        ref="serviceUnavailableDialog"
        persistent
        content-class="service-unavailable-dialog-outer-wrapper"
    >
        <q-card class="service-unavailable-dialog-wrapper">
            <q-card-section>
                <service-unavailable-content
                    :is-maintenance="isMaintenance"
                    @available="onAvailable"
                />
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import { useI18n } from '@/composables/i18n'
import { useQuasar } from '@/composables/quasar'
import { useRouter } from '@/composables/router'
import { ref, onBeforeUnmount, onMounted, computed } from 'vue'
import { EventBus } from '@/event-bus'
import ServiceUnavailableContent from '@/components/ServiceUnavailableContent.vue'
import { Cookies } from 'quasar'

export default {
    name: 'ServiceUnavailableOverlay',
    components: {
        ServiceUnavailableContent,
    },
    setup () {
        const router = useRouter()
        const $q = useQuasar()
        const { t } = useI18n()
        const isMaintenance = ref(false)
        const serviceUnavailableDialog = ref(null)

        const isLoggedIn = computed(() => {
            return Cookies.has('jwt_header_payload')
        })

        function show ({ isMaintenance: maintenanceMode = false } = {}) {
            if (router.currentRoute.name === 'service-unavailable') {
                return
            }

            isMaintenance.value = maintenanceMode
            serviceUnavailableDialog.value.show()
        }

        function hide () {
            serviceUnavailableDialog.value.hide()
        }

        function onAvailable () {
            $q.notify({
                type: 'positive',
                message: t('common.notifications.maintenance.system-available-again'),
            })

            hide()
        }

        onMounted(() => {
            EventBus.$on('serviceUnavailable:show', show)
        })

        onBeforeUnmount(() => {
            EventBus.$off('serviceUnavailable:show', show)
        })

        return {
            isMaintenance,
            isLoggedIn,
            serviceUnavailableDialog,
            hide,
            onAvailable,
        }
    },
}
</script>

<style lang="scss">
.service-unavailable-dialog-outer-wrapper {
    // Added to blur the content when dialog is shown to "hide" potentially confidential info.
    // <style> cannot be `scoped` if Dialog itself should be styled due to Quasar placement of dialogs.
    // If style must be scoped, consider using a wrapper component or alternative approach to blur the background.
    .q-dialog__backdrop {
        backdrop-filter: blur(5px);
    }

    .service-unavailable-dialog-wrapper {
        width: 40vw;
        min-width: $sizeAppMinWidth;
        max-width: 800px;

        text-align: center;
        font-variant-numeric: tabular-nums; // Unfortunately, most of the available web fonts do not have/offer this feature.
    }
}
</style>
